module.exports = __webpack_public_path__ + "static/media/2s.66242909.png";